import { makeStyles } from "@material-ui/core";
import { blueContrast, buttonHover } from "../../hooks/use-map-theme-styles";

export default makeStyles(({ spacing, palette }) => ({
	nestedDialogFilter: {
		borderLeft: `1px solid ${blueContrast}`,
		marginTop: spacing(1),
		marginLeft: spacing(3),
		paddingLeft: spacing(1),
	},
	listItemControl: {
		padding: 0,
		paddingRight: 6,
	},
	selectAllItemControl: {
		paddingLeft: 0,
		paddingRight: 6,
	},
	label: {
		whiteSpace: "nowrap",
		textTransform: "none",
		fontWeight: 600,
	},
	buttonFilter: {
		whiteSpace: "nowrap",
		textTransform: "none",
		fontWeight: 600,
		"&:hover": {
			boxShadow: "none",
			backgroundColor: buttonHover,
		},
	},
	scrollable: {
		overflowY: "auto",
		padding: "8px 10px",
		overscrollBehavior: "contain",
	},
	dialogScrollable: {
		padding: "8px 16px",
	},
	dialogTitle: {
		padding: "4px 24px",
	},
	disabledText: {
		color: "#c0bcbc",
	},
	primaryText: {
		color: "#367bf5",
	},
	divider: {
		height: "1px",
	},
	textButton: {
		padding: 0,
		"&:hover": {
			boxShadow: "none",
			backgroundColor: "transparent",
		},
	},
	ellipsisRule: {
		maxWidth: 300,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	popover: {
		pointerEvents: "none",
	},
	popoverContent: {
		pointerEvents: "auto",
	},
	scrollContainer: {
		"& .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar": {
			display: "none",
		},
	},
	hidden: {
		opacity: 0,
		pointerEvents: "none",
	},
	customTextField: {
		"& input::placeholder": {
			fontSize: "14px",
			letterSpacing: "0.15px",
			opacity: 1,
			fontWeight: 600,
			color: "#969392",
		},
	},
	controlLabel: {
		margin: 0,
	},
	fullWidth: {
		width: "100%",
		margin: 0,
		padding: 0,
	},
	grayTextField: {
		width: 240,
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: palette.inputTableDivider.main,
		},
		"& .MuiOutlinedInput-root": {
			borderRadius: "2px",
			backgroundColor: palette.inputTableDivider.main,
		},
		"& .MuiSelect-outlined.MuiSelect-outlined": {
			padding: "4px 24px 4px 8px",
		},
		"& .MuiOutlinedInput-input": {
			padding: "4px",
		},
	},
}));
